import * as React from "react";
import { Flex, Text, Card } from "@radix-ui/themes";
import type { Organization, StrapiMetadata } from "../../../types";

interface OrganizationSelectorProps {
  organizations: Organization[];
  onSelectOrganization: (orgId: StrapiMetadata['documentId']) => void;
}

export const OrganizationSelector: React.FC<OrganizationSelectorProps> = ({
  organizations,
  onSelectOrganization,
}) => {
  return (
    <Flex direction="column" gap="3" style={{ width: "100%" }}>
      {organizations
        ?.filter((org) => org.publishedAt !== null)
        .map((org) => (
          <Card
            key={org.documentId}
            asChild
            style={{ cursor: "pointer", transition: "background-color 0.2s" }}
            onClick={() => onSelectOrganization(org.documentId)}
          >
            <Flex align="center" justify="between" p="3">
              <Text size="3" weight="medium">
                {org.name}
              </Text>
            </Flex>
          </Card>
        ))}
    </Flex>
  );
};
